/* istanbul ignore file */
export class Smartsheet {
    accessToken: string;
    clearPermission?: boolean = false;
    dateModified: Date;
    executedBy?: string;
    extendedPrimaryKey?: any;
    filter: string;
    filterColumns?: any[] = [];
    id: string;
    insertPermission?: boolean = false;
    isExtended?: boolean = false;
    isSaving?: boolean = false;
    modifiedBy?: string;
    name: string;
    projectId: string;
    pullColumns?: any[];
    pullStatus: string;
    pullStatusMessage: string;
    pullStatusTimestamp: Date;
    pushColumns?: any[];
    pushStatus: string;
    pushStatusMessage: string;
    pushStatusTimestamp: Date;
    smartsheet?: any;
    smartsheetPrimaryKey?: any;
    token?: string;
}
